import React, { useEffect } from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import withState from 'recompose/withState';
import withHandlers from 'recompose/withHandlers';
import { FormControlLabel, Paper, Radio, RadioGroup } from '@material-ui/core';
import CancelButton from '../atoms/CancelButton';
import ChangeButton from '../atoms/ChangeButton';
import ProgressDialog from './ProgressDialog';
import ConfirmDialog from './ConfirmDialog';
import {
  updateGochiKidDonateFlag,
  UPDATE_GOCHI_KID_DONATE_FLAG_SUCCESS
} from '../../actions/Groups';
import { sendLogin } from '../../auth/Auth';

const styles = {
  title: {
    fontWeight: 'bolder',
    margin: '20px 0 10px 40px'
  },
  mainPaper: {
    minWidth: 400,
    margin: '10px 0px 10px',
    padding: '10px 26px 10px 26px',
    display: 'flex'
  },
  radioGroup: {
    width: '100%',
    justifyContent: 'space-between'
  }
};

const enhance = compose(
  connect(
    null,
    dispatch => ({
      actions: bindActionCreators(
        {
          updateGochiKidDonateFlag
        },
        dispatch
      )
    })
  ),
  withState('openProgress', 'updateOpenProgress', false),
  withState('openConfirm', 'updateOpenConfirm', false),
  withState('loading', 'setLoading', false),
  withState('message', 'setMessage', ''),
  withState('errorMessage', 'setErrorMessage', ''),
  withState('gochiKidDonateFlag', 'setGochiKidDonateFlag', props => {
    return props.oldGochiKidDonateFlag;
  }),
  withHandlers({
    checkSession: props => data => {
      if (
        data.error === true &&
        typeof data.payload !== 'undefined' &&
        data.payload.status === 403
      ) {
        sendLogin(props);
      }
      return data;
    }
  })
);

const Main = enhance(
  ({
    actions,
    classes,
    openChange,
    updateOpenChange,
    message,
    setMessage,
    openProgress,
    updateOpenProgress,
    loading,
    setLoading,
    gochiKidDonateFlag,
    setGochiKidDonateFlag,
    openConfirm,
    updateOpenConfirm,
    groupId,
    oldGochiKidDonateFlag,
    handleChangePageAction,
    checkSession,
    errorMessage,
    setErrorMessage
  }) => {
    useEffect(() => {
      if (openChange) {
        setGochiKidDonateFlag(oldGochiKidDonateFlag);
      }
    }, [openChange]);

    function progressOkAction() {
      updateOpenProgress(false);
      setMessage('');
    }

    function cancelAction() {
      updateOpenChange(false);
    }

    async function changeAction() {
      setLoading(true);
      updateOpenProgress(true);
      updateOpenConfirm(false);
      const response = await actions
        .updateGochiKidDonateFlag(groupId, {
          gochiKidDonateFlag
        })
        .then(data => checkSession(data));
      if (response.type === UPDATE_GOCHI_KID_DONATE_FLAG_SUCCESS) {
        handleChangePageAction();
        setMessage('更新しました。');
        setLoading(false);
      } else {
        setErrorMessage('エラーが発生しました！');
        updateOpenProgress(false);
        setLoading(false);
      }
    }

    function openConfirmPopup() {
      updateOpenChange(false);
      updateOpenConfirm(true);
    }

    return (
      <>
        <Dialog
          open={openChange}
          onClose={cancelAction}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <Typography component="p" className={classes.title}>
              寄付可能設定
            </Typography>
            <Paper className={classes.mainPaper} elevation={1}>
              <RadioGroup
                row
                value={gochiKidDonateFlag}
                onChange={e => {
                  const allowed = parseInt(e.target.value, 10);
                  setGochiKidDonateFlag(allowed);
                }}
                className={classes.radioGroup}
              >
                <FormControlLabel
                  value={1}
                  control={<Radio color="primary" />}
                  label={
                    <Typography style={{ fontWeight: 'bolder' }}>
                      寄付可能
                    </Typography>
                  }
                />
                <FormControlLabel
                  value={0}
                  control={<Radio color="primary" />}
                  label={
                    <Typography style={{ fontWeight: 'bolder' }}>
                      寄付不可能
                    </Typography>
                  }
                />
              </RadioGroup>
            </Paper>
          </DialogContent>
          <div style={{ margin: '0 0 10px 10px' }}>
            <CancelButton onClickAction={cancelAction} color="primary" />
            <ChangeButton onClickAction={openConfirmPopup} />
          </div>
        </Dialog>
        <ConfirmDialog
          openConfirm={openConfirm}
          updateOpenConfirm={updateOpenConfirm}
          message="設定を更新します。よろしいでしょうか。"
          okAction={changeAction}
        />
        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={message}
        />
        <ProgressDialog
          openProgress={errorMessage !== ''}
          progressOkAction={() => setErrorMessage('')}
          loading={false}
          resultMessage={errorMessage}
        />
      </>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
